import styled from "styled-components";
import { MdExpandMore } from "react-icons/md";
export const GridCustom = styled.div`
    display:block;
    grid-template-columns: 100%;
    &.noCreative{
        grid-template-columns: 100%;
    }
`
export const GridForm = styled.div`

`